<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M31.26 7.21a1.51 1.51 0 00-1.5 0L14.11 16H5.5A1.5 1.5 0 004 17.5v13A1.5 1.5 0 005.5 32h8.61l15.65 8.81a1.51 1.51 0 001.5 0A1.48 1.48 0 0032 39.5v-31a1.48 1.48 0 00-.74-1.29zM7 19h6v10H7zm22 17.94l-13-7.32V18.38l13-7.32zM39.89 13.51a1.5 1.5 0 00-2.21 2 12.47 12.47 0 010 16.92 1.5 1.5 0 002.21 2 15.47 15.47 0 000-21z"/><path d="M36.1 17.91a1.5 1.5 0 10-2.2 2 6 6 0 010 8.12 1.5 1.5 0 00.1 2.15 1.53 1.53 0 001 .39 1.49 1.49 0 001.1-.48 9 9 0 000-12.18z"/></svg>